// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-post {
    background-color: #333;
    color: #fff;
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 20px;
    position: relative;
  }
  
  .blog-title {
    font-size: 1.5em;
    margin-bottom: 10px;
    text-align: center;
  }
  
  .blog-subtitle {
    font-size: 1.2em;
    margin-bottom: 15px;
    color: #92a91d;
  }
  
  .blog-image {
    max-width: 100%;
    border-radius: 5px;
    margin: 10px 0;
  }
  
  .blog-content {
    margin: 20px 0;
  }

  .blog-hashtags {
    display: flex;
    flex-wrap: wrap; /* Allows hashtags to wrap onto the next line */
    gap: 5px; /* Provides spacing between hashtags, replaces margin-right */
  }
  
  .blog-hashtags span {
    background-color: #92a91d;
    color: #333;
    padding: 5px 10px;
    border-radius: 20px;
    /* margin-right: 5px; */
  }
  
  /* Different image positions */
  .blog-post.left .blog-image {
    float: left;
    margin-right: 20px;
  }
  
  .blog-post.right .blog-image {
    float: right;
    margin-left: 20px;
  }

  /* Mobile-specific styles */
@media (max-width: 768px) {
  .blog-post {
    padding: 10px; /* Reduce padding for mobile view */
  }

  .blog-title {
    font-size: 1.2em; /* Adjust font size */
  }

  .blog-subtitle {
    font-size: 1em; /* Adjust font size */
  }

  .blog-content {
    margin: 15px 0;
  }

  .blog-image {
    margin: 5px 0;
  }
}

  `, "",{"version":3,"sources":["webpack://./src/components/BlogPost.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe,EAAE,+CAA+C;IAChE,QAAQ,EAAE,6DAA6D;EACzE;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,8BAA8B;EAC9B;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA,2BAA2B;AAC7B;EACE;IACE,aAAa,EAAE,mCAAmC;EACpD;;EAEA;IACE,gBAAgB,EAAE,qBAAqB;EACzC;;EAEA;IACE,cAAc,EAAE,qBAAqB;EACvC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".blog-post {\n    background-color: #333;\n    color: #fff;\n    padding: 20px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    position: relative;\n  }\n  \n  .blog-title {\n    font-size: 1.5em;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n  \n  .blog-subtitle {\n    font-size: 1.2em;\n    margin-bottom: 15px;\n    color: #92a91d;\n  }\n  \n  .blog-image {\n    max-width: 100%;\n    border-radius: 5px;\n    margin: 10px 0;\n  }\n  \n  .blog-content {\n    margin: 20px 0;\n  }\n\n  .blog-hashtags {\n    display: flex;\n    flex-wrap: wrap; /* Allows hashtags to wrap onto the next line */\n    gap: 5px; /* Provides spacing between hashtags, replaces margin-right */\n  }\n  \n  .blog-hashtags span {\n    background-color: #92a91d;\n    color: #333;\n    padding: 5px 10px;\n    border-radius: 20px;\n    /* margin-right: 5px; */\n  }\n  \n  /* Different image positions */\n  .blog-post.left .blog-image {\n    float: left;\n    margin-right: 20px;\n  }\n  \n  .blog-post.right .blog-image {\n    float: right;\n    margin-left: 20px;\n  }\n\n  /* Mobile-specific styles */\n@media (max-width: 768px) {\n  .blog-post {\n    padding: 10px; /* Reduce padding for mobile view */\n  }\n\n  .blog-title {\n    font-size: 1.2em; /* Adjust font size */\n  }\n\n  .blog-subtitle {\n    font-size: 1em; /* Adjust font size */\n  }\n\n  .blog-content {\n    margin: 15px 0;\n  }\n\n  .blog-image {\n    margin: 5px 0;\n  }\n}\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
